import { render, staticRenderFns } from "./NormalSearchNav216.vue?vue&type=template&id=b904f8ca&scoped=true&"
import script from "./NormalSearchNav216.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav216.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b904f8ca",
  null
  
)

export default component.exports